export default __webpack_public_path__ + "static/media/VEA_Recommended.27668a9e.svg";